// EnablePopupWrapper.jsx
import { useRef } from 'react';
import { useAppState } from '../../../contexts/AppStateContext';
import { useNavigate } from 'react-router-dom';

const EnablePopupWrapper = ({
    product,
    productUrl,
    children,
    classNames = '',
}) => {
    const navigate = useNavigate();
    const { 
        productPopupData, 
        setProductPopupData,
        openProductPopup  // You can use this instead if you prefer
    } = useAppState();
    
    const buttonRef = useRef(null);
    
    const handleInteraction = () => {
        // Store the current button as the element to return focus to
        window.lastFocusedElement = buttonRef.current;
        
        // Use either setProductPopupData or openProductPopup
        setProductPopupData(product);
        // or: openProductPopup(product);
        
        window.history.pushState({}, '', productUrl);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleInteraction();
        }
    };

    // If children is a button, we'll just add our handlers to it
    if (children?.type === 'button') {
        return React.cloneElement(children, {
            onClick: handleInteraction,
            onKeyDown: handleKeyDown,
            'aria-expanded': productPopupData?.id === product.id ? 'true' : 'false',
            'aria-haspopup': 'dialog',
            role: 'button',
            ref: buttonRef
        });
    }

    // Otherwise, wrap children in a button
    return (
        <button
            className={`btn-reset ${classNames}`}
            onClick={handleInteraction}
            onKeyDown={handleKeyDown}
            aria-expanded={productPopupData?.id === product.id ? 'true' : 'false'}
            aria-haspopup="dialog"
            type="button"
            ref={buttonRef}
        >
            {children}
        </button>
    );
};

export default EnablePopupWrapper;
